/**
 * Iframe Resizer Module
 * Listens for postMessage events from embedded Nuxt iframes and adjusts their height
 */

(function() {
  'use strict';

  // Buffer to add to height to prevent scrollbars (added on parent side to avoid feedback loops)
  const HEIGHT_BUFFER = 10;

  // Store iframe info for matching messages to iframes
  const iframeEntries = [];

  /**
   * Initialize iframe tracking
   */
  function initIframes() {
    // Find all iframes that could be from our Nuxt app (maps and schedules)
    const iframes = document.querySelectorAll('iframe[src*="/maps/"], iframe[src*="/schedules/"]');
    
    iframes.forEach(iframe => {
      try {
        const url = new URL(iframe.src);
        const origin = url.origin;

        iframeEntries.push({
          iframe,
          origin,
          lastHeight: 0
        });
        
        // Set initial styles for smooth resizing
        iframe.style.transition = 'height 0.2s ease-out';
        iframe.style.width = '100%';
        iframe.style.border = 'none';
        iframe.style.display = 'block';
        iframe.setAttribute('scrolling', 'no');
      } catch (e) {
        console.warn('[iframeResizer] Invalid iframe src:', iframe.src);
      }
    });
  }

  /**
   * Handle incoming postMessage events
   */
  function handleMessage(event) {
    if (!event.data || !event.data.type) return;

    // Handle resize messages
    if (event.data.type === 'uecc-iframe-resize') {
      handleResize(event);
    }
    
    // Handle scroll-to-map messages (mobile)
    if (event.data.type === 'uecc-scroll-to-map') {
      handleScrollToMap(event);
    }
  }

  /**
   * Handle iframe resize messages
   */
  function handleResize(event) {
    const { height } = event.data;
    
    // Validate height
    if (typeof height !== 'number' || height <= 0) {
      return;
    }

    // Prefer matching by source window, fallback to origin
    const entry = iframeEntries.find(({ iframe }) => iframe.contentWindow === event.source) ||
      iframeEntries.find(({ origin }) => origin === event.origin);

    if (!entry) return;

    // Add buffer on parent side to prevent scrollbars without causing feedback loops
    const nextHeight = Math.ceil(height + HEIGHT_BUFFER);
    if (entry.lastHeight === nextHeight) return;
    entry.lastHeight = nextHeight;

    requestAnimationFrame(() => {
      entry.iframe.style.height = nextHeight + 'px';
    });
  }

  /**
   * Handle scroll-to-map messages - scrolls the map container into view on mobile
   */
  function handleScrollToMap(event) {
    const entry = iframeEntries.find(({ iframe }) => iframe.contentWindow === event.source) ||
      iframeEntries.find(({ origin }) => origin === event.origin);
    
    if (entry) {
      const iframe = entry.iframe;
      
      // Calculate position to center the map in viewport
      const iframeRect = iframe.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const iframeCenter = iframeRect.top + window.scrollY + (iframeRect.height / 2);
      const scrollTarget = iframeCenter - (viewportHeight / 2);
      
      // Smooth scroll to center the map
      window.scrollTo({
        top: Math.max(0, scrollTarget),
        behavior: 'smooth'
      });
    }
  }

  /**
   * Initialize the module
   */
  function init() {
    // Initialize iframes
    initIframes();
    
    // Listen for resize messages
    window.addEventListener('message', handleMessage);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
